import script from "./loginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./loginForm.vue?vue&type=script&setup=true&lang=js"

import "./loginForm.vue?vue&type=style&index=0&id=21b11163&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b11163"]])

export default __exports__